import {Component, Input, OnInit} from '@angular/core';
import {ConfigService} from "../../../services/config.service";

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css'],
    standalone: false
})
export class SidebarComponent implements OnInit {
  constructor(private configService: ConfigService) { }

  public entityType = this.configService.entityType;


  ngOnInit() {
  }

}
